import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-indicadores-edit',
  templateUrl: './detalhe-projeto-indicadores-edit.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-edit.component.scss']
})
export class DetalheProjetoIndicadoresEditComponent implements OnInit {

  idProjeto: number;
  indicador: IndicadoresProjeto;
  cloneIndicador: boolean;
  infoProjeto: ProjetoCadastro;
  actionLabel: string = 'Novo';

  constructor(
    public activatedRoute: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });
    
    this.cloneIndicador = this.activatedRoute.snapshot.data['clone'];
    this.indicador = this.activatedRoute.snapshot.data['entity'];

    if (this.indicador?.id) {
      this.actionLabel = this.cloneIndicador ? 'Clone' : 'Editar';
    }

    if (this.cloneIndicador) {
      EventSharedService.get('reloadLayout').emit();
    }
  }
}
